import Main from './Main'
import Lista from './components/OrgaoApreensor'
import Novo from './components/NovoOrgaoApreensor'

export default [
  {
    path: 'orgao-apreensor',
    name: 'config.orgao.apreensor',
    component: Main,
    redirect: { name: 'config.orgao.apreensor.list' },
    children: [
      {
        path: '/',
        name: 'config.orgao.apreensor.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.orgao.apreensor.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.orgao.apreensor.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/orgao-apreensor/routes.js